/**
 * customerCountry.js — resolve/save customer shipping country for cart currency display.
 */

import { resolveCountryCode } from './addressUtils';

const STORAGE_KEY = 'cranford_customer_country';

export function readStoredCustomerCountry() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return resolveCountryCode(parsed) || null;
  } catch {
    return null;
  }
}

/** Country code + name for reference currency (GBP, AUD, EUR) on cart. */
export function readStoredCustomerCurrencyContext() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const countryCode = resolveCountryCode(parsed) || 'CA';
    return {
      countryCode,
      countryName: parsed.countryName || parsed.country || '',
    };
  } catch {
    return null;
  }
}

export function saveCustomerCountry(addressLike = {}) {
  const countryCode = resolveCountryCode(addressLike);
  if (!countryCode) return;

  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    countryCode,
    countryName: addressLike.countryName || addressLike.country || '',
    country: addressLike.country || addressLike.countryName || '',
  }));
}

export function getCustomerCurrencyContextFromProfile(username) {
  if (!username) return null;

  try {
    const saved = localStorage.getItem(`userProfile_${username}`);
    if (!saved) return null;

    const profile = JSON.parse(saved);
    const countryCode = resolveCountryCode({
      country: profile.country,
      countryCode: profile.countryCode,
      countryName: profile.countryName,
    }) || 'CA';
    return {
      countryCode,
      countryName: profile.countryName || profile.country || '',
    };
  } catch {
    return null;
  }
}

export function getCustomerCurrencyContextFromApiProfile(profile) {
  if (!profile) return null;
  const countryCode = resolveCountryCode({
    country: profile.country,
    countryCode: profile.countryCode,
    countryName: profile.countryName,
  }) || 'CA';
  return {
    countryCode,
    countryName: profile.country || profile.countryName || '',
  };
}

export function getCustomerCountryFromProfile(username) {
  if (!username) return null;

  try {
    const saved = localStorage.getItem(`userProfile_${username}`);
    if (!saved) return null;

    const profile = JSON.parse(saved);
    return resolveCountryCode({
      country: profile.country,
      countryCode: profile.countryCode,
      countryName: profile.countryName,
    }) || null;
  } catch {
    return null;
  }
}

export function getCustomerCountryFromApiProfile(profile) {
  if (!profile) return null;
  return resolveCountryCode({
    country: profile.country,
    countryCode: profile.countryCode,
    countryName: profile.countryName,
  }) || null;
}
